<div class="app-gonvarri-order-express">
  <div class="row">
    <div>
      <div class="express-checkout">
        <h2 class="headline"> {{ 'cartItems.orderExpress.title' | cxTranslate }} </h2>
        <strong>{{ 'cartItems.orderExpress.important' | cxTranslate }}</strong>
        <ul>
          <li>
            {{ 'cartItems.orderExpress.topic1' | cxTranslate }}
          </li>
          <li>
            {{ 'cartItems.orderExpress.topic2' | cxTranslate }}
          </li>
          <li>
            {{ 'cartItems.orderExpress.topic3' | cxTranslate }}
          </li>
        </ul>
        <div class="checkbox">
          <label>
            <input
              type="checkbox"
              id="express-checkout-checkbox"
              class="express-checkout-checkbox"
              [(ngModel)]="isAgreed"
            />
            {{ 'cartItems.orderExpress.agree' | cxTranslate }}</label
          >
        </div>
        <form
          id="expressCheckoutForm"
          (submit)="addToCart()"
        >
          <div class="row">
            <div class="input">
              <input
                id="orderNumber"
                name="orderNumber"
                class="express-order-number form-control input-sm"
                [placeholder]="'cartItems.orderExpress.orderNumber' | cxTranslate"
                type="text"
                required
                [(ngModel)]="orderNumber"
                [disabled]="!isAgreed"
              />
            </div>
            <div>
              <button
                id="express-checkout-button"
                class="btn btn-primary btn-small"
                path="expressCheckoutButton"
                [disabled]="!isAgreed"
              >
              {{ 'cartItems.orderExpress.checkout' | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
